var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"compass"},[_c('div',{staticClass:"round-bg"}),_vm._v(" "),_c('triangle',{staticClass:"triangle",style:({transform: 'rotate('+ _vm.rotation +'deg)'})})],1)}
var staticRenderFns = []

export { render, staticRenderFns }